import * as React from "react";
import {
    Flex,
    Box,
} from "@chakra-ui/react";
import {RootState} from "@src/store";
import {useAppSelector} from "@store/hooks";
import i18n from "i18next";
import {useTranslation} from "react-i18next";
import useTitle from "@hooks/useTitle";
import LoginForm from "@pages/auth/_LoginForm";

const Login = () => {
    const {t} = useTranslation();
    const lang = i18n.language;
    const {websiteSettings} = useAppSelector((state: RootState) => state.websiteSettings);

    useTitle(t(("documentTitle.auth")))

    return (
        <Flex
            height={"100vh"}
            position={"relative"}
            overflow={"hidden"}
            align={"center"}
            justifyContent={"center"}
            bg={"custom.brand_primaryDark"}
        >
            <Box
                pos={"absolute"}
                top={"-30vw"}
                left={"-20vw"}
                w={"50vw"}
                h={"50vw"}
                transform={"rotate(45deg)"}
                bg={"custom.brand_loginBlock"}
                borderRadius={"10vw"}
            />
            <Flex
                pos={"relative"}
                zIndex={"1"}
                flexDir={"column"}
                w={"480px"}
                mx={{base: "16px", md: "0"}}
                p={{base: "80px 32px 32px", md: "80px 60px 60px"}}
                bg={"custom.gray_50"}
            >
                <LoginForm websiteSettings={websiteSettings} lang={lang} />
            </Flex>
            <Box
                pos={"absolute"}
                bottom={"-30vw"}
                right={"-20vw"}
                w={"50vw"}
                h={"50vw"}
                transform={"rotate(45deg)"}
                bg={"custom.brand_loginBlock"}
                borderRadius={"10vw"}
            />
        </Flex>
    );
};

export default Login;
